import React from 'react';

const PackageDetails = ({ selectedPackage }) => {
    console.log("selectedPackage",selectedPackage)
    return (
        <div className="py-2">
            <div className="p-2 rounded-md bg-gray-100 shadow-md">
                <div className="flex justify-between items-center">
                    {selectedPackage?.detailTitle && (
                        <h2 className="text-lg font-semibold text-gray-800">
                            {selectedPackage.detailTitle}
                        </h2>
                    )}

                    {selectedPackage?.totalDays && (
                        <div className="px-3 py-1 bg-blue-500 text-white text-sm rounded-md">
                            {selectedPackage.totalDays} Day(s)
                        </div>
                    )}
                </div>

                {selectedPackage?.thumbnailImage && selectedPackage.thumbnailImage.trim() !== '' && (
                    <div className="mt-3 w-full h-32 rounded-md overflow-hidden flex justify-center items-center">
                        <img 
                            src={selectedPackage.thumbnailImage} 
                            alt="Package Thumbnail" 
                            className="w-full h-full object-cover"
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default React.memo(PackageDetails);